module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (3).0a623d66.svg";